// Platform descriptions and benefits data
export const PLATFORMS_INFO = {
  // Secreto #1
  "www.certiviaje.com": {
    description: "Certificaciones para agentes de viajes",
    benefits: ["Certificaciones oficiales", "Capacitación continua", "Reconocimiento profesional"],
    tutorialUrl: "https://www.youtube.com/results?search_query=certiviaje+tutorial"
  },
  "www.bombazoo.com": {
    description: "Plataforma de reservas de hoteles y tours",
    benefits: ["Mejores tarifas", "Comisiones atractivas", "Inventario global"],
    tutorialUrl: "https://www.youtube.com/results?search_query=bombazoo+agentes+viajes"
  },
  "www.disneysuperfacil.com": {
    description: "Especialista en paquetes Disney",
    benefits: ["Paquetes exclusivos Disney", "Herramientas de cotización", "Soporte especializado"],
    tutorialUrl: "https://www.youtube.com/results?search_query=disney+super+facil+tutorial"
  },

  // Secreto #2
  "www.dividelo.com": {
    description: "Opciones de pago a plazos para viajeros",
    benefits: ["Divide pagos sin intereses", "Aumenta conversiones", "Facilita ventas grandes"],
    tutorialUrl: "https://www.youtube.com/results?search_query=dividelo+pagos+viajes"
  },

  // Secreto #3
  "www.vagabondos.com": {
    description: "Tours y experiencias de aventura",
    benefits: ["Experiencias únicas", "Grupos pequeños", "Guías expertos"],
    tutorialUrl: "https://www.youtube.com/results?search_query=vagabondos+tours+tutorial"
  },
  "www.ratehawk.com": {
    description: "Motor de reservas B2B para hoteles",
    benefits: ["Más de 2M de hoteles", "Tarifas netas", "API disponible"],
    tutorialUrl: "https://www.youtube.com/results?search_query=ratehawk+tutorial+español"
  },
  "www.bedsonline.com": {
    description: "Mayorista global de hoteles y tours",
    benefits: ["Red mundial Hotelbeds", "Transfers incluidos", "Markup flexible"],
    tutorialUrl: "https://www.youtube.com/results?search_query=bedsonline+tutorial+agentes"
  },
  "www.veturis.com": {
    description: "Plataforma de reservas turísticas",
    benefits: ["Hoteles y circuitos", "Tecnología avanzada", "Soporte 24/7"],
    tutorialUrl: "https://www.youtube.com/results?search_query=veturis+travel+tutorial"
  },

  // Secreto #4
  "www.clubviajemos.us": {
    description: "Portal principal de Club Viajemos USA",
    benefits: ["Recursos exclusivos", "Comunidad de agentes", "Entrenamientos en vivo"],
    tutorialUrl: "https://www.youtube.com/results?search_query=club+viajemos+tutorial"
  },

  // Secreto #5
  "www.compartamoslo.com": {
    description: "Sistema de referidos y marketing",
    benefits: ["Genera leads automáticos", "Marketing viral", "Comisiones por referidos"],
    tutorialUrl: "https://www.youtube.com/results?search_query=compartamoslo+marketing"
  },
  "www.carlosmiamifernandez.com": {
    description: "Mentoría y capacitación en ventas",
    benefits: ["Estrategias probadas", "Coaching personal", "Crecimiento acelerado"],
    tutorialUrl: "https://www.youtube.com/results?search_query=carlos+miami+fernandez"
  },
  "www.hotmart.com": {
    description: "Plataforma de productos digitales y cursos",
    benefits: ["Cursos de capacitación", "Productos de afiliado", "Ingresos pasivos"],
    tutorialUrl: "https://www.youtube.com/results?search_query=hotmart+tutorial+español"
  },

  // Organizador
  "www.viajemoscorp.com": {
    description: "Sistema de productividad y prospección",
    benefits: ["Bloques de 15 minutos", "Tareas por pilares", "Máxima productividad"],
    tutorialUrl: "https://www.youtube.com/results?search_query=viajemos+corp+productividad"
  },
  "clubviajemos.com/codigosdeviaje500dolares?ref=carlos.fernandez": {
    displayName: "CODIGOS DE U$500",
    description: "Este secreto va a cambiar tu sistema de prospeccion",
    benefits: ["500 codigos listos para regalar", "Captacion masiva de prospectos", "Envio por WhatsApp y Email"],
    tutorialUrl: null
  },
  "clubviajemos.com/comoganardinero": {
    displayName: "COMO GANAR DINERO",
    description: "Sistema completo de Alianzas Universitarias LATAM — paso a paso",
    benefits: ["Modelo probado", "Roadmap de ingresos", "Template para tu agencia"],
    tutorialUrl: null
  },
  "clubviajemos.com/vendeconia": {
    displayName: "VENDE CON IA",
    description: "AI Funnel + Asistente IA que vende por ti 24/7",
    benefits: ["Automatizacion total", "Cierre inteligente", "Escala sin limites"],
    tutorialUrl: null
  },
  "clubviajemos.com/prospecciondigital": {
    displayName: "PROSPECCION DIGITAL",
    description: "Programa PhD de prospeccion — formacion profesional completa",
    benefits: ["Metodo estructurado", "Contenido avanzado", "Resultados medibles"],
    tutorialUrl: null
  }
};

export default PLATFORMS_INFO;
